import { useCallback, useState } from 'react'

import { resetAntForm } from '../utils'

const useFormDirty = form => {
  const [isDirty, setIsDirty] = useState(false)

  const setToNotDirty = useCallback(() => setIsDirty(false), [])
  const setToDirty = useCallback(() => setIsDirty(true), [])

  const resetForm = useCallback(
    () => resetAntForm(form, setToNotDirty),
    [form, setToNotDirty],
  )

  return { isDirty, setToDirty, resetForm }
}

export default useFormDirty
